export default __webpack_public_path__ + "dd2e1f15ccadb2b45ed127f92eb23085.svg";